module.exports = __webpack_public_path__ + "img/ma.6e255873.svg";